import React, {
  Dispatch,
  FC,
  SetStateAction,
  SyntheticEvent,
  useCallback,
} from "react";
import { AlertColor } from "@mui/material/Alert/Alert";
import { Alert, Snackbar } from "@mui/material";

export type PromptProps = {
  isOpen: boolean;
  message: string;
  severity: AlertColor;
  autoHeightDuration?: number;
  onPromptClose?: () => void;
};

export interface PromptSnackBarProps {
  promptProps: PromptProps;
  setPromptProps: Dispatch<SetStateAction<PromptProps>>;
}

const PromptSnackBar: FC<PromptSnackBarProps> = ({
  promptProps,
  setPromptProps,
}) => {
  /**
   * Handle prompt message close
   */
  const handlePromptClose = useCallback(
    (_?: SyntheticEvent | Event, reason?: string): void => {
      if (reason === "clickaway") {
        return;
      }

      promptProps.onPromptClose?.();
      setPromptProps({ ...promptProps, isOpen: false });
    },
    [promptProps, setPromptProps],
  );

  return (
    <Snackbar
      // anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={promptProps.isOpen}
      autoHideDuration={promptProps.autoHeightDuration}
      onClose={handlePromptClose}
    >
      <Alert
        onClose={handlePromptClose}
        severity={promptProps.severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {promptProps.message}
      </Alert>
    </Snackbar>
  );
};

export default PromptSnackBar;
